import React from 'react';
import { motion } from 'framer-motion';
import { usePermissions } from '../hooks/usePermissions';

const PermissionMotionButton = ({ 
  children, 
  permission, 
  className = "", 
  disabled = false, 
  onClick, 
  title,
  style = {},
  whileHover = { scale: 1.05 },
  whileTap = { scale: 0.95 },
  ...props 
}) => {
  const { hasPermission } = usePermissions();
  
  const hasRequiredPermission = hasPermission(permission);
  const isDisabled = !hasRequiredPermission || disabled;
  
  const buttonStyle = {
    ...style,
    cursor: hasRequiredPermission ? "pointer" : "not-allowed",
    opacity: hasRequiredPermission ? 1 : 0.6
  };
  
  const buttonClassName = hasRequiredPermission 
    ? className 
    : className.replace(/btn-\w+/g, 'btn-secondary');
  
  const buttonTitle = hasRequiredPermission 
    ? title 
    : `ليس لديك صلاحية للقيام بهذا الإجراء`;
  
  const handleClick = (e) => {
    if (hasRequiredPermission && onClick) {
      onClick(e);
    }
  };
  
  const motionProps = hasRequiredPermission 
    ? { whileHover, whileTap }
    : {};
  
  return (
    <motion.button
      {...props}
      {...motionProps}
      className={buttonClassName}
      disabled={isDisabled}
      onClick={handleClick}
      title={buttonTitle}
      style={buttonStyle}
    >
      {children}
    </motion.button>
  );
};

export default PermissionMotionButton;
